import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import newRequest from '../../utils/newRequest'
import { handleError } from '../../utils/error'
import CustomSnakebar from '../../utils/CustomSnakebar'
import { BeatLoader } from 'react-spinners'
import "./allAssets.scss"

const AddAllAsset = () => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState(null)
  const [error, setError] = useState(null)
  
  // Dropdown data
  const [categories, setCategories] = useState([])
  const [employees, setEmployees] = useState([])
  const [assetConditions, setAssetConditions] = useState([])
  const [boughtOptions, setBoughtOptions] = useState([])
  const [cities, setCities] = useState([])
  const [regions, setRegions] = useState([])
  const [departments, setDepartments] = useState([])
  const [brands, setBrands] = useState([])
  
  // Form state
  const [formData, setFormData] = useState({
    QTY: 1,
    MajorCategory: '',
    MajorCategoryDescription: '',
    MInorCategory: '',
    MinorCategoryDescription: '',
    aSSETdESCRIPTION: '',
    cOUNTRY: 'SA',
    rEGION: '',
    CityName: '',
    departmDaoentCode: '',
    DaoName: '',
    BusinessUnit: '',
    BUILDINGNO: '',
    FLOORNO: '',
    EMPLOYEEID: '',
    ponUmber: '',
    DeliveryNoteNo: '',
    Supplier: '',
    InvoiceNo: '',
    InvoiceDate: '',
    ModelofAsset: '',
    Manufacturer: '',
    Ownership: '',
    Bought: '',
    TerminalID: '',
    ATMNumber: '',
    aSSETcONDITION: '',
    assettYPE: '',
    buildingName: '',
    buildingAddress: '',
    Podate: '',
    sERIALnUMBER: '',
    UserLoginID: ''
  })

  useEffect(() => {
    // Get user login ID from session
    const userLoginId = window.sessionStorage.getItem("userLoginID")
    if (userLoginId) {
      setFormData(prev => ({ ...prev, UserLoginID: JSON.parse(userLoginId) }))
    }

    // Fetch dropdown data
    fetchCategories()
    fetchEmployees()
    fetchAssetConditions()
    fetchBoughtOptions()
    fetchCities()
    fetchRegions()
    fetchDepartments()
  }, [])

  const fetchCategories = async () => {
    try {
      const response = await newRequest.get("/GetAllMAINSUBSeriesNo")
      setCategories(response?.data || [])
      if (response?.data?.length > 0) {
        const first = response.data[0]
        setFormData(prev => ({
          ...prev,
          MajorCategory: first.MainCategoryCode || '',
          MajorCategoryDescription: first.MainDescription || '',
          MInorCategory: first.SubCategoryCode || '',
          MinorCategoryDescription: first.SubDescription || ''
        }))
        fetchBrands(first.MainCategoryCode, first.SubCategoryCode)
      }
    } catch (err) {
      handleError(err)
    }
  }

  const fetchBrands = async (majorCode, minorCode) => {
    if (!majorCode || !minorCode) return
    try {
      const response = await newRequest.post("/GetmakelistById", {
        TblMakeMainCode: minorCode,
        tblMajorCode: majorCode
      })
      setBrands(response?.data?.recordset || [])
    } catch (err) {
      handleError(err)
    }
  }

  const fetchEmployees = async () => {
    try {
      const response = await newRequest.get("/GetAllEmployeeList")
      setEmployees(response?.data || [])
    } catch (err) {
      handleError(err)
    }
  }

  const fetchAssetConditions = async () => {
    try {
      const response = await newRequest.get("/GetAllAssetCondition")
      setAssetConditions(response?.data || [])
    } catch (err) {
      handleError(err)
    }
  }

  const fetchBoughtOptions = async () => {
    try {
      const response = await newRequest.get("/GetAllAssetConditionBought")
      setBoughtOptions(response?.data || [])
    } catch (err) {
      handleError(err)
    }
  }

  const fetchCities = async () => {
    try {
      const response = await newRequest.get("/GetAllCity")
      setCities(response?.data || [])
    } catch (err) {
      handleError(err)
    }
  }

  const fetchRegions = async () => {
    try {
      const response = await newRequest.get("/GetAllRegion")
      setRegions(response?.data || [])
    } catch (err) {
      handleError(err)
    }
  }

  const fetchDepartments = async () => {
    try {
      const response = await newRequest.get("/GetAllDepartmentList")
      setDepartments(response?.data || [])
    } catch (err) {
      handleError(err)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    
    // Handle category change
    if (name === 'category') {
      const category = categories.find(c => 
        `${c.MainCategoryCode}-${c.SubCategoryCode}` === value
      )
      if (category) {
        setFormData(prev => ({
          ...prev,
          MajorCategory: category.MainCategoryCode,
          MajorCategoryDescription: category.MainDescription,
          MInorCategory: category.SubCategoryCode,
          MinorCategoryDescription: category.SubDescription
        }))
        fetchBrands(category.MainCategoryCode, category.SubCategoryCode)
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)
    setMessage(null)

    try {
      const response = await newRequest.post("/PostAssetMasterEncodeAssetCapture", formData)
      setMessage(response?.data?.message || t("Asset added successfully"))
      setTimeout(() => {
        navigate('/admin/all-assets')
      }, 1500)
    } catch (err) {
      setError(err?.response?.data?.message || t("Failed to add asset"))
      handleError(err)
    } finally {
      setIsLoading(false)
    }
  }

  const resetSnakeBarMessages = () => {
    setError(null)
    setMessage(null)
  }

  return (
    <div className="allAssetForm">
      {isLoading && (
        <div className='loading-spinner-background'
          style={{
            zIndex: 9999, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}
        >
          <BeatLoader size={18} color={"#6439ff"} loading={isLoading} />
        </div>
      )}

      {message && (
        <CustomSnakebar message={message} severity="success" onClose={resetSnakeBarMessages} />
      )}
      {error && (
        <CustomSnakebar message={error} severity="error" onClose={resetSnakeBarMessages} />
      )}

      <div className="newContainer">
        <div className="top">
          <span className="topSpan">
            <h1>{t("Add New Asset")}</h1>
            <button type="button" onClick={() => navigate('/admin/all-assets')}>
              {t("Go Back")}
            </button>
          </span>
        </div>

        <div className="bottom">
          <form onSubmit={handleSubmit} className="assetForm">
            <div className="formSection">
              <h3>{t("Category Information")}</h3>
              <div className="formRow">
                <div className="formInput">
                  <label>{t("Category")}*</label>
                  <select
                    name="category"
                    value={`${formData.MajorCategory}-${formData.MInorCategory}`}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">{t("Select Category")}</option>
                    {categories.map((cat, idx) => (
                      <option key={idx} value={`${cat.MainCategoryCode}-${cat.SubCategoryCode}`}>
                        {cat.MainDescription} - {cat.SubDescription}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("Major Category")}</label>
                  <input type="text" value={formData.MajorCategory} readOnly />
                </div>
                <div className="formInput">
                  <label>{t("Minor Category")}</label>
                  <input type="text" value={formData.MInorCategory} readOnly />
                </div>
              </div>
            </div>

            <div className="formSection">
              <h3>{t("Asset Details")}</h3>
              <div className="formRow">
                <div className="formInput">
                  <label>{t("Asset Description")}*</label>
                  <input
                    type="text"
                    name="aSSETdESCRIPTION"
                    value={formData.aSSETdESCRIPTION}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="formInput">
                  <label>{t("Serial Number")}</label>
                  <input
                    type="text"
                    name="sERIALnUMBER"
                    value={formData.sERIALnUMBER}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Asset Condition")}</label>
                  <select
                    name="aSSETcONDITION"
                    value={formData.aSSETcONDITION}
                    onChange={handleInputChange}
                  >
                    <option value="">{t("Select Condition")}</option>
                    {assetConditions.map((cond, idx) => (
                      <option key={idx} value={cond.TblConditionCode}>
                        {cond.TblConditionDescription}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("Asset Type")}</label>
                  <input
                    type="text"
                    name="assettYPE"
                    value={formData.assettYPE}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="formSection">
              <h3>{t("Location Information")}</h3>
              <div className="formRow">
                <div className="formInput">
                  <label>{t("Country")}</label>
                  <input
                    type="text"
                    name="cOUNTRY"
                    value={formData.cOUNTRY}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Region")}</label>
                  <select
                    name="rEGION"
                    value={formData.rEGION}
                    onChange={handleInputChange}
                  >
                    <option value="">{t("Select Region")}</option>
                    {regions.map((reg, idx) => (
                      <option key={idx} value={reg.RegionCode}>
                        {reg.RegionName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("City")}</label>
                  <select
                    name="CityName"
                    value={formData.CityName}
                    onChange={handleInputChange}
                  >
                    <option value="">{t("Select City")}</option>
                    {cities.filter(c => !formData.rEGION || c.RegionCode === formData.rEGION).map((city, idx) => (
                      <option key={idx} value={city.CityName}>
                        {city.CityName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("Department")}</label>
                  <select
                    name="DaoName"
                    value={formData.DaoName}
                    onChange={handleInputChange}
                  >
                    <option value="">{t("Select Department")}</option>
                    {departments.map((dept, idx) => (
                      <option key={idx} value={dept.DaoName}>
                        {dept.DaoName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("Business Unit")}</label>
                  <input
                    type="text"
                    name="BusinessUnit"
                    value={formData.BusinessUnit}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Building Name")}</label>
                  <input
                    type="text"
                    name="buildingName"
                    value={formData.buildingName}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Building Address")}</label>
                  <input
                    type="text"
                    name="buildingAddress"
                    value={formData.buildingAddress}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Building No")}</label>
                  <input
                    type="text"
                    name="BUILDINGNO"
                    value={formData.BUILDINGNO}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Floor No")}</label>
                  <input
                    type="text"
                    name="FLOORNO"
                    value={formData.FLOORNO}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="formSection">
              <h3>{t("Manufacturer & Model")}</h3>
              <div className="formRow">
                <div className="formInput">
                  <label>{t("Manufacturer")}</label>
                  <select
                    name="Manufacturer"
                    value={formData.Manufacturer}
                    onChange={handleInputChange}
                  >
                    <option value="">{t("Select Manufacturer")}</option>
                    {brands.map((brand, idx) => (
                      <option key={idx} value={brand.TblMakeName}>
                        {brand.TblMakeName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("Model")}</label>
                  <input
                    type="text"
                    name="ModelofAsset"
                    value={formData.ModelofAsset}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="formSection">
              <h3>{t("Purchase Information")}</h3>
              <div className="formRow">
                <div className="formInput">
                  <label>{t("PO Number")}</label>
                  <input
                    type="text"
                    name="ponUmber"
                    value={formData.ponUmber}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("PO Date")}</label>
                  <input
                    type="date"
                    name="Podate"
                    value={formData.Podate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Delivery Note No")}</label>
                  <input
                    type="text"
                    name="DeliveryNoteNo"
                    value={formData.DeliveryNoteNo}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Supplier")}</label>
                  <input
                    type="text"
                    name="Supplier"
                    value={formData.Supplier}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Invoice No")}</label>
                  <input
                    type="text"
                    name="InvoiceNo"
                    value={formData.InvoiceNo}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Invoice Date")}</label>
                  <input
                    type="date"
                    name="InvoiceDate"
                    value={formData.InvoiceDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Bought")}</label>
                  <select
                    name="Bought"
                    value={formData.Bought}
                    onChange={handleInputChange}
                  >
                    <option value="">{t("Select")}</option>
                    {boughtOptions.map((bought, idx) => (
                      <option key={idx} value={bought.TblConditionBoughtCode}>
                        {bought.TblConditionBoughtDescription}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("Ownership")}</label>
                  <input
                    type="text"
                    name="Ownership"
                    value={formData.Ownership}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="formSection">
              <h3>{t("Other Information")}</h3>
              <div className="formRow">
                <div className="formInput">
                  <label>{t("Employee ID")}</label>
                  <select
                    name="EMPLOYEEID"
                    value={formData.EMPLOYEEID}
                    onChange={handleInputChange}
                  >
                    <option value="">{t("Select Employee")}</option>
                    {employees.map((emp, idx) => (
                      <option key={idx} value={emp.EmpID}>
                        {emp.EmpName} ({emp.EmpID})
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formInput">
                  <label>{t("Terminal ID")}</label>
                  <input
                    type="text"
                    name="TerminalID"
                    value={formData.TerminalID}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("ATM Number")}</label>
                  <input
                    type="text"
                    name="ATMNumber"
                    value={formData.ATMNumber}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="formInput">
                  <label>{t("Quantity")}</label>
                  <input
                    type="number"
                    name="QTY"
                    value={formData.QTY}
                    onChange={handleInputChange}
                    min="1"
                  />
                </div>
              </div>
            </div>

            <div className="buttonAdd">
              <button type="submit" disabled={isLoading}>
                {isLoading ? t("Adding...") : t("Add Asset")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddAllAsset
